var _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBallShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 42,
    viewBox: "0 0 69 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 21,
    rx: 34.5,
    ry: 21,
    fill: "#D7894C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallShadow);
export default __webpack_public_path__ + "static/media/ball-shadow.8f5a9a7927ae615513a8854d61615102.svg";
export { ForwardRef as ReactComponent };